export default __webpack_public_path__ + "static/media/meuhedet.6745ae64.svg";